/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        // Show or hide the sticky footer button
        $('.navbar-nav .dropdown .dropdown-toggle').on('click',function(){
          window.location.href = $(this).attr('href');
        });

        var posy = $('.banner > .wrapper-menu').offset();

        $(window).scroll(function() {

          if ($(this).scrollTop() > posy.top) {
            // $('.go-top').fadeIn(200);
            $('.banner > .wrapper-menu').css({'top': ($(this).scrollTop() - posy.top)+'px','z-index':20});
          } else {
            // $('.go-top').fadeOut(200);
            $('.banner > .wrapper-menu').removeAttr('style');
          }
        });

        $(".register-button a,a.registration,a.ptp-button").click(function(e){
          e.preventDefault();
          $("#myModal").modal();
        });

        $('.propinsiselect').change(function(){

          //Call ajax
          $.ajax({
            url:"wp-admin/admin-ajax.php",
            type:'POST',
            data:'action=cabang&ID=' + $(this).val(),
            beforeSend: function(){
              $('.cabang-gym').html('<option value="">--- Loading ---</option>');
            },
            success:function(results) {
              //alert(results);
              $('.cabang-gym').html(results);
            }
          });
        });

        $('.cabang-gym').change(function(){

          //console.log($(this).val()+'-'+$('.periode-membership').val());

          //Call ajax
          $.ajax({
            url:"wp-admin/admin-ajax.php",
            type:'POST',
            data:'action=pricemember&cabang=' + $(this).val()+'&periode='+$('.periode-membership').val(),
            beforeSend: function(){
              $('.price-membership').val('--- Loading ---');
            },
            success:function(results) {
              //alert(results);
              $('.price-membership').val(results);
            }
          });

        });

        $('.periode-membership').change(function(){
          //console.log($(this).val()+'-'+$('.cabang-gym').val());

          //Call ajax
          $.ajax({
            url:"wp-admin/admin-ajax.php",
            type:'POST',
            data:'action=pricemember&cabang=' + $('.cabang-gym').val()+'&periode='+$(this).val(),
            beforeSend: function(){
              $('.price-membership').val('--- Loading ---');
            },
            success:function(results) {
              //alert(results);
              $('.price-membership').val(results);
            }
          });

        });

         $('input[type=date]').datepicker({
            changeMonth: true,
            changeYear: true
         });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
